var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37508 4.6665C3.65679 4.6665 2.96791 4.95185 2.46 5.45976C1.95209 5.96767 1.66675 6.65654 1.66675 7.37484V8.4165H18.3334V7.37484C18.3334 7.01917 18.2634 6.66699 18.1273 6.3384C17.9911 6.00981 17.7917 5.71125 17.5402 5.45976C17.2887 5.20826 16.9901 5.00877 16.6615 4.87266C16.3329 4.73656 15.9807 4.6665 15.6251 4.6665H4.37508ZM18.3334 9.6665H1.66675V13.6248C1.66675 14.3431 1.95209 15.032 2.46 15.5399C2.96791 16.0478 3.65679 16.3332 4.37508 16.3332H15.6251C15.9807 16.3332 16.3329 16.2631 16.6615 16.127C16.9901 15.9909 17.2887 15.7914 17.5402 15.5399C17.7917 15.2884 17.9911 14.9899 18.1273 14.6613C18.2634 14.3327 18.3334 13.9805 18.3334 13.6248V9.6665ZM13.1251 12.5832H15.2084C15.3742 12.5832 15.5331 12.649 15.6504 12.7662C15.7676 12.8834 15.8334 13.0424 15.8334 13.2082C15.8334 13.3739 15.7676 13.5329 15.6504 13.6501C15.5331 13.7673 15.3742 13.8332 15.2084 13.8332H13.1251C12.9593 13.8332 12.8004 13.7673 12.6831 13.6501C12.5659 13.5329 12.5001 13.3739 12.5001 13.2082C12.5001 13.0424 12.5659 12.8834 12.6831 12.7662C12.8004 12.649 12.9593 12.5832 13.1251 12.5832Z",
    fill: "#c3c3c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarIcon2);
export default __webpack_public_path__ + "static/media/navbar-icon2.1d2ae3e2f86a5b5805d226c92ee6f76a.svg";
export { ForwardRef as ReactComponent };